import { validateForm as baseValidateForm } from '../components/formConfig';

export const tipoNotaOptions = [
  { value: '1', label: 'Normal' },
  { value: '2', label: 'Devolucao' }
];

export const motivoDevolucaoOptions = [
  { value: '1', label: 'Erro Cliente' },
  { value: '2', label: 'Erro Operador Logistico' },
  { value: '3', label: 'Outros' }
];

export const emptyDepositoNotaFiscalForm = {
  id: '',
  chaveNFe: '',
  numeroNF: '',
  serieNF: '',
  tipoNota: tipoNotaOptions[0],
  motivoDevolucao: '',
  descricaoDevolucao: '',
  numeroPedidoPaletizacao: '',
  numeroPedidoEtiquetagem: '',
  cnpjCliente: '',
  nomeCliente: '',
  tipoOperacao: '',
  nomeDestinatario: '',
  nomeRemetente: '',
  nomeUsuarioLeitura: '',
  nomeResponsavelComercial: '',
  nomeResponsavelLancamento: '',
  nomeResponsavelFechamento: '',
  dataChegada: '',
  dataLeitura: '',
  dataConferencia: '',
  dataArmazenagem: '',
  dataAgendamento: '',
  dataSaida: '',
  dataEnvioCanhoto: '',
  quantidadeTotalCaixas: '',
  quantidadeTotalPaletes: '',
  quantidadeTotalEtiquetas: '',
  quantidadePaletesCobranca: '',
  quantidadeEtiquetasCobranca: '',
  idDepositoTabelaPreco: '',
  valorUnPallet: '',
  valorUnEtiqueta: '',
  valorUnArmazenagemPallet: '',
  freetime: '',
  valorTotalPaletizacao: '',
  valorTotalEtiquetagem: '',
  valorTotalArmazenagemPallet: '',
  valorTotalEmitidoPaletizacao: '',
  valorTotalEmitidoEtiquetagem: '',
  usuarioEmissaoPaletizacao: '',
  usuarioEmissaoEtiquetagem: '',
  protocoloPedidoTMSPaletizacao: '',
  protocoloPedidoTMSEtiquetagem: '',
  urlImagemCanhoto: '',
  nomeUsuarioEnvioCanhoto: '',
  mudancaTabelaPrecoManual: false,
  cobrancaPaletizacaoRealizada: false,
  cobrancaEtiquetagemRealizada: false,
  cobrancaArmazenagemRealizada: false,
  existeDivergencia: false,
  finalizado: false,
  usuarioFinalizacao: '',
  descricaoDivergencia: '',
  observacoes: ''
};

export const depositoNotaFiscalFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'chaveNFe',
      label: 'Chave NFE',
      placeholder: 'Informe a chave de acesso da NF-e (espacos sao ignorados; 44 digitos)',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
      maxLength: 80
    }
  ],
  [
    {
      name: 'numeroNF',
      label: 'Numero NF',
      placeholder: 'Digite o numero da NF',
      component: 'FormField',
      type: 'text',
      colProps: { md: 3 },
      required: true,
      maxLength: 45,
      validation: {
        required: 'Numero NF e obrigatorio'
      }
    },
    {
      name: 'serieNF',
      label: 'Serie NF',
      placeholder: 'Digite a serie da NF',
      component: 'FormField',
      type: 'text',
      colProps: { md: 2 },
      maxLength: 45
    },
    {
      name: 'cnpjCliente',
      label: 'CNPJ Cliente',
      placeholder: 'Digite o CNPJ do cliente',
      component: 'MaskedInput',
      type: 'text',
      colProps: { md: 3 },
      maxLength: 18,
      mask: [
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
      ],
      guide: false,
      required: true,
      validation: {
        required: 'CNPJ e obrigatorio'
      }
    },
    {
      name: 'nomeCliente',
      label: 'Nome Cliente',
      placeholder: 'Digite o nome do cliente',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'tipoOperacao',
      label: 'Tipo Operacao',
      placeholder: 'Digite o tipo de operacao',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    },
    {
      name: 'tipoNota',
      label: 'Tipo Nota',
      placeholder: 'Selecione...',
      component: 'SearchSelect',
      colProps: { md: 4 },
      minSearchLength: 0,
      options: tipoNotaOptions
    },
    {
      name: 'motivoDevolucao',
      label: 'Motivo Devolucao',
      placeholder: 'Selecione...',
      component: 'SearchSelect',
      colProps: { md: 4 },
      minSearchLength: 0,
      options: motivoDevolucaoOptions
    },
    {
      name: 'descricaoDevolucao',
      label: 'Descricao Devolucao',
      placeholder: 'Digite o motivo/descricao da devolucao',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 12 },
      rows: 3
    }
  ],
  [
    {
      name: 'dataChegada',
      label: 'Data Chegada',
      placeholder: 'Selecione data e hora de chegada',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataAgendamento',
      label: 'Data Agendamento',
      placeholder: 'Selecione data e hora de agendamento',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    },
    {
      name: 'dataSaida',
      label: 'Data Saida/Entrega',
      placeholder: 'Selecione data e hora de saida',
      component: 'DatePickers',
      type: 'datetime',
      colProps: { md: 3 }
    }
    // {
    //   name: 'dataLeitura',
    //   label: 'Data Leitura',
    //   placeholder: 'Selecione data e hora de leitura',
    //   component: 'DatePickers',
    //   type: 'datetime',
    //   colProps: { md: 3 }
    // },
    // {
    //   name: 'dataConferencia',
    //   label: 'Data Conferencia',
    //   placeholder: 'Selecione data e hora de conferencia',
    //   component: 'DatePickers',
    //   type: 'datetime',
    //   colProps: { md: 3 }
    // },
    // {
    //   name: 'dataArmazenagem',
    //   label: 'Data Armazenagem',
    //   placeholder: 'Selecione data e hora de armazenagem',
    //   component: 'DatePickers',
    //   type: 'datetime',
    //   colProps: { md: 3 }
    // }
  ],
  [
    {
      name: 'quantidadeTotalCaixas',
      label: 'Qtde Caixas',
      placeholder: 'Digite a quantidade de caixas',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'quantidadeTotalPaletes',
      label: 'Qtde Paletes',
      placeholder: 'Digite a quantidade de paletes',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    },
    {
      name: 'quantidadeTotalEtiquetas',
      label: 'Qtde Etiquetas',
      placeholder: 'Digite a quantidade de etiquetas',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'quantidadePaletesCobranca',
      label: 'Qtde Paletes Cobranca/Retrabalho',
      placeholder: 'Digite a quantidade de paletes para cobranca',
      component: 'FormField',
      type: 'number',
      colProps: { md: { span: 3, offset: 3 } }
    },
    {
      name: 'quantidadeEtiquetasCobranca',
      label: 'Qtde Etiquetas Cobranca/Retrabalho',
      placeholder: 'Digite a quantidade de etiquetas para cobranca',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'idDepositoTabelaPreco',
      label: 'Tabela Preco',
      placeholder: 'Selecione a tabela de preco ou cadastre uma nova',
      component: 'SelectWithModal',
      colProps: { md: 3 }
    },
    {
      name: 'valorUnPallet',
      label: 'Valor Palete',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'valorUnEtiqueta',
      label: 'Valor Etiqueta',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'valorUnArmazenagemPallet',
      label: 'Valor Arm. Palete',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    }
  ],
  [
    {
      name: 'valorTotalPaletizacao',
      label: 'Total Paletizacao',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'valorTotalEtiquetagem',
      label: 'Total Etiquetagem',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'valorTotalArmazenagemPallet',
      label: 'Total Arm. Pallet',
      component: 'CurrencyInput',
      placeholder: '0,00',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'freetime',
      label: 'Freetime',
      placeholder: 'Dias de freetime',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 },
      readOnly: true,
      disabled: true
    }
  ],
  [
    {
      name: 'observacoes',
      label: 'Observacoes',
      placeholder: 'Digite observacoes',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 3
    },
    {
      name: 'descricaoDivergencia',
      label: 'Descricao Divergencia',
      placeholder: 'Digite a divergencia',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 3
    }
  ],
  [
    {
      name: 'mudancaTabelaPrecoManual',
      label: 'Mudanca Tabela Manual',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' },
      readOnly: true,
      disabled: true
    },
    {
      name: 'cobrancaPaletizacaoRealizada',
      label: 'Cobranca Paletizacao',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' }
    },
    {
      name: 'cobrancaEtiquetagemRealizada',
      label: 'Cobranca Etiquetagem',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' }
    },
    {
      name: 'cobrancaArmazenagemRealizada',
      label: 'Cobranca Armazenagem',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' }
    },
    {
      name: 'existeDivergencia',
      label: 'Existe Divergencia',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' }
    },
    {
      name: 'finalizado',
      label: 'Finalizado',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 'auto' }
    }
  ]
];

export const depositoNotaFiscalFormSections = () => [
  { title: '', rows: [0, 1, 2] },
  { title: '', rows: [3] },
  { title: '', rows: [4, 5] },
  { title: '', rows: [6, 7] },
  { title: '', rows: [8] },
  { title: '', rows: [9] },
  { title: '', rows: [10, 11] }
];

export const validateDepositoNotaFiscalForm = (values) => baseValidateForm(values);
